import zxcvbn from "zxcvbn";

export function getPasswordStrengthScore(password: string): number {
  if (!password) return 0;
  return zxcvbn(password).score;
}

export function isPasswordStrengthBlocked(password: string): boolean {
  return (
    password.length > 0 &&
    (password.length < 8 || getPasswordStrengthScore(password) < 2)
  );
}

type StrengthDisplay = {
  label: string;
  className: string;
  showHint: boolean;
};

function getStrengthDisplay(score: number): StrengthDisplay {
  if (score <= 1) {
    return { label: "Weak", className: "text-destructive", showHint: true };
  }
  if (score === 2) {
    return { label: "Fair", className: "text-amber-500", showHint: false };
  }
  return { label: "Strong", className: "text-primary", showHint: false };
}

interface PasswordStrengthIndicatorProps {
  password: string;
}

export const PasswordStrengthIndicator = ({
  password,
}: PasswordStrengthIndicatorProps) => {
  if (!password) return null;

  const score = getPasswordStrengthScore(password);
  const { label, className, showHint } = getStrengthDisplay(score);

  return (
    <div className="space-y-1">
      <p className={`text-xs ${className}`}>{label}</p>
      {showHint ? (
        <p className="text-xs text-muted-foreground">
          Add numbers or special characters to strengthen your password.
        </p>
      ) : null}
    </div>
  );
};
